var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Card, Table } from "@atlassiansox/microscopekit";
import { errorList, statusLozenge } from "../../utils/Utils";
import SectionMessage from "@atlaskit/section-message";
import { TimeComponent } from "../TimeComponent";
import styled from "styled-components";
export var FaultExecutionView = function (props) {
    var parameters = props.faultExecution.parameters;
    var faultAction = parameters === null || parameters === void 0 ? void 0 : parameters.fault;
    var faultDefinition = parameters === null || parameters === void 0 ? void 0 : parameters.arguments;
    var fisMetadata = parameters === null || parameters === void 0 ? void 0 : parameters.fis_metadata;
    return (React.createElement(Card, null,
        React.createElement(Table, { cells: [
                ["Fault", faultAction ? faultAction : ""],
                ["Status", statusLozenge(props.faultExecution.status)],
                [
                    "Fault Definition",
                    React.createElement("ul", null,
                        " ",
                        Object.entries(faultDefinition ? faultDefinition : {}).map(function (entry) {
                            var _a = __read(entry, 2), key = _a[0], value = _a[1];
                            return (React.createElement(ListItem, null,
                                key,
                                " : ",
                                JSON.stringify(value, null, 2)));
                        }),
                        " ")
                ],
                fisMetadata
                    ? [
                        "AWS FIS Details",
                        React.createElement("ul", null,
                            " ",
                            React.createElement(ListItem, null,
                                "FIS Experiment ID",
                                " :",
                                " ",
                                fisMetadata.fis_experiment_id
                                    ? fisMetadata.fis_experiment_id
                                    : "AWS FIS experiment id not found"),
                            React.createElement(ListItem, null,
                                "FIS Template ID",
                                " :",
                                " ",
                                fisMetadata.fis_template_id
                                    ? fisMetadata.fis_template_id
                                    : "AWS FIS template id not found"),
                            fisMetadata.fis_resolved_targets === null ? (React.createElement(ListItem, null,
                                "Affected resources",
                                " :",
                                " ",
                                "AWS FIS did not identify any target(s) for your service in the target_az yet")) : fisMetadata.fis_resolved_targets.length === 0 ? (React.createElement(ListItem, null,
                                "Affected resources",
                                " :",
                                " ",
                                "AWS FIS did not identify any target(s) for your service in the target_az yet")) : (React.createElement(ListItem, null,
                                "Affected resources",
                                " :",
                                React.createElement("ul", null, Object.entries(fisMetadata.fis_resolved_targets
                                    ? fisMetadata.fis_resolved_targets
                                    : {}).map(function (entry) {
                                    var _a = __read(entry, 2), value = _a[1];
                                    return (React.createElement(ListItem, null, value.targetInformation.arn));
                                })))),
                            " ")
                    ]
                    : ["", ""]
            ] }),
        React.createElement("div", { hidden: errorList.indexOf(props.faultExecution.status.toLowerCase()) < 0 },
            React.createElement(SectionMessage, { appearance: "error", title: "Execution Failed" }, props.faultExecution.statusMessage)),
        React.createElement(TimeComponent, { createdAt: props.faultExecution.createdAt, updatedAt: props.faultExecution.updatedAt, status: props.faultExecution.status })));
};
export var ListItem = styled.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: normal;\n  word-wrap: break-word;\n"], ["\n  white-space: normal;\n  word-wrap: break-word;\n"])));
var templateObject_1;
